import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { GetFileObjectById } from "../../../objectStorage/slice";
import { colors } from "../../../ui/colors";
import { EditIcon } from "../../../ui/icons/edit";
import { Sort } from "../../../ui/icons/sort";
import { entryMeansOptions, formatterDate, optionsFormatter } from "../../../utils";
import { DepartureProtocolDTO } from "./dataService/dto";
import { GetAllDepartureProtocolAttachments, GetAllDepartureProtocols, setDepartureProtocolIdToUpdate, setGetAllDepartureProtocolOrderFilter, setGetAllDepartureProtocolSortFilter, setSelectedProtNumber, setUpdateCorriere, setUpdateDataBolgetta, setUpdateDataReceive, setUpdateDataRicezioneCompiutaGiacenza, setUpdateDataRitornoErratoIndirizzo, setUpdatedFile, setUpdatedPPAttachmentFile, setUpdateNumeroRaccomandataErratoIndirizzo, setUpdateNumRaccomandata, setUpdatePEC, setUpdatePostaElettronica, setUpdatePPCustomerIds, setUpdatePPCustomersNotRegistered, setUpdatePPDepartureAttachmentIds, setUpdatePPDepartureChannel, setUpdatePPDepartureObjectId, setUpdatePPHeadquarter, setUpdatePPLinkExistingProtocol, setUpdatePPNation, setUpdatePPObjectSpec, setUpdatePPProtocolDate, setUpdatePPRegion, setUpdatePPSend, setUpdatepPSender, setUpdatePPTotalPage, setUpdatePPUsersVisibility, setUpdateRaccomandataAr, setUpdateRaccomandataMano } from "./slice";


export function DepartureListProtocol() {
    const navigate = useNavigate()

    const dispatch = useAppDispatch()
    const departureProtocolState = useAppSelector(state => state.departureProtocol)
    const objectStorageState = useAppSelector(state => state.objectStorage)
    const handleOnEdit = (data: DepartureProtocolDTO) => {
        if (data.fileId !== null && data.fileId !== undefined) {

            dispatch(GetFileObjectById(data.fileId))
        }
        dispatch(setDepartureProtocolIdToUpdate(data.id))
        dispatch(setUpdatePPProtocolDate(data.protocolDate))
        dispatch(setUpdatePPHeadquarter(data.headQuarter))
        dispatch(setUpdatePPNation(data.nation))
        dispatch(setUpdatePPRegion(data.region))
        dispatch(setUpdatepPSender(data.receiver))
        if (data.customersInfo !== null)
            dispatch(setUpdatePPCustomerIds(data.customersInfo.map(c => c.id)))
        dispatch(setUpdatePPCustomersNotRegistered(data.customersNotRegistered))
        dispatch(setUpdatePPDepartureObjectId(data.departureObject.id))
        dispatch(setUpdatePPObjectSpec(data.objectSpec))
        dispatch(setUpdatePPTotalPage(data.totalPage))
        dispatch(setUpdatePPDepartureChannel(data.departureChannel))
        dispatch(setUpdatePPSend(data.send))
        dispatch(setUpdatePPUsersVisibility(data.usersVisibility))
        dispatch(setUpdatePPLinkExistingProtocol(data.linkExistingProtocol))
        dispatch(setUpdatePPDepartureAttachmentIds(data.departureAttachments.map(att => att.id)))
        dispatch(setUpdateNumRaccomandata(data.numeroRaccomandata))
        dispatch(setUpdateDataBolgetta(data.dataBolgetta))
        dispatch(setUpdateDataRicezioneCompiutaGiacenza(data.dataRicezioneCompiutaGiacenza))
        dispatch(setUpdateDataRitornoErratoIndirizzo(data.dataRitornoErratoIndirizzo))
        dispatch(setUpdateNumeroRaccomandataErratoIndirizzo(data.numeroRaccomandataErratoIndirizzo))
        dispatch(setUpdateCorriere(data.corriere))
        dispatch(setUpdateRaccomandataMano(data.raccomandataMano))
        dispatch(setUpdatePostaElettronica(data.postaElettronica))
        dispatch(setUpdateDataReceive(data.receive))
        dispatch(setUpdateRaccomandataAr(data.raccomandataAr))
        dispatch(setUpdatePEC(data.postaElettronicaCertificata))
        dispatch(setUpdatedPPAttachmentFile(data.attachmentFile))
        dispatch(setSelectedProtNumber(data.headQuarter + ' P' + data.protocolNumber + " del " + formatterDate(data.protocolDate)))
        if (data.fileId === null || data.fileId === undefined) {
            navigate('/editDepartureProtocol')
        }
    }

    useEffect(() => {
        if (objectStorageState.getFileObjectByIdStatus === 'successfully') {
            dispatch(setUpdatedFile(objectStorageState.getFileObjectByIdResponse))
            navigate('/editDepartureProtocol')
        }

    }, [objectStorageState.getFileObjectByIdStatus])

    useEffect(() => {
        // dispatch(GetAllDepartureProtocols(departureProtocolState.getAllDepartureProtocolFilters))
        dispatch(GetAllDepartureProtocolAttachments({
            itemsPerPage: 0,
            page: 0
        }))
    }, [])

    useEffect(() => {
        dispatch(GetAllDepartureProtocols({ ...departureProtocolState.getAllDepartureProtocolFilters, sort: departureProtocolState.getAllDepartureProtocolFilters.sort, order: departureProtocolState.getAllDepartureProtocolFilters.order, page: departureProtocolState.getAllDepartureProtocolFilters.page }))
    }, [departureProtocolState.getAllDepartureProtocolFilters.page, departureProtocolState.getAllDepartureProtocolFilters.sort, departureProtocolState.getAllDepartureProtocolFilters.order])

    const sortableCols: { label: string; field: string }[] = [
        { label: 'Numero', field: 'protocolNumber' },
        { label: 'Sede', field: 'headQuarter' },
        { label: 'Anno', field: 'year' },
        { label: 'Data', field: 'protocolDate' },
        { label: 'Mittente', field: 'receiver' },
        { label: 'Cliente', field: 'customer' },
        { label: 'Oggetto', field: 'departureObject' },
        { label: 'Oggetto Extra', field: 'objectSpec' },
        { label: 'Mezzo Entrata', field: 'departureChannel' },
        { label: 'Funzionario', field: 'user' },
    ]

    const SortableTh = ({ label, onSort }: { label: string; onSort?: () => void }) => (
        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">
            <div className="flex flex-row items-center gap-1 w-full">
                {label}
                <Sort size={14} color={colors.white} onClick={() => onSort && onSort()} />
            </div>
        </th>
    )

    return (
        <div className="w-full px-6 pb-6">
            <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                <table id="users-table" className="w-full border-collapse text-sm">
                    <thead>
                        <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                            {sortableCols.map((col) => (
                                <SortableTh
                                    key={col.label}
                                    label={col.label}
                                    onSort={() => {
                                        dispatch(setGetAllDepartureProtocolSortFilter(col.field))
                                        dispatch(setGetAllDepartureProtocolOrderFilter(departureProtocolState.getAllDepartureProtocolFilters.order === true ? false : true))
                                    }}
                                />
                            ))}
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Allegati</th>
                            <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[40px]" />
                        </tr>
                    </thead>
                    <tbody>
                        {
                            (departureProtocolState.getAllDepartureProtocolsResponse?.data && departureProtocolState.getAllDepartureProtocolsResponse?.data.length > 0) &&
                            departureProtocolState.getAllDepartureProtocolsResponse?.data.map((protocol, index) =>
                                <tr key={index}
                                    className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                >
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap font-semibold">{protocol.headQuarter} {'P' + protocol.protocolNumber}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{protocol.headQuarter}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{protocol.year}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap text-xs">{formatterDate(protocol.protocolDate)}</td>
                                    <td className="px-3 py-2 text-neutral-700">{protocol.receiver}</td>
                                    <td className="px-3 py-2 text-neutral-700 min-w-[160px]">
                                        {protocol.customersInfo && protocol.customersInfo.map((customer, index, customers) =>
                                            <span>{customer.companyName}{index < customers.length - 1 && ', '}</span>
                                        )}
                                    </td>
                                    <td className="px-3 py-2 text-neutral-700">
                                        {
                                            protocol.departureObject.description
                                        }
                                    </td>
                                    <td className="px-3 py-2 text-neutral-700">{protocol.objectSpec}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                        {
                                            protocol.departureChannel &&
                                            optionsFormatter(protocol.departureChannel, entryMeansOptions)
                                        }
                                    </td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{`${protocol.user.name} ${protocol.user.surname}`}</td>
                                    <td className="px-3 py-2 text-neutral-700 min-w-[140px]">
                                        {
                                            protocol.departureAttachments.map((att, index) => {
                                                if (index !== protocol.departureAttachments.length - 1)
                                                    return `[${att.coding}] - `
                                                return `[${att.coding}]`
                                            })
                                        }
                                    </td>
                                    <td className="px-3 py-2 w-[40px] text-center">
                                        <div className="flex items-center justify-center">
                                            <button
                                                className="relative group p-1 rounded hover:bg-neutral-100 transition-colors"
                                                onClick={() => {
                                                    handleOnEdit(protocol)
                                                }}
                                                aria-label="Modifica protocollo"
                                                title="Modifica protocollo"
                                            >
                                                <EditIcon color={"Orange"} size={18} />
                                                <span className="absolute bottom-full right-0 mb-1 hidden group-hover:block px-2 py-1 text-xs text-white bg-neutral-800 rounded whitespace-nowrap pointer-events-none z-10">
                                                    Modifica Protocollo
                                                </span>
                                            </button>

                                            {/* <div className="pl-3 flex align-items-center">
                                                <button onClick={() => { }}>
                                                    <TrashIcon color={"Orange"} size={0} />
                                                </button>
                                            </div> */}
                                        </div>
                                    </td>
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}